import objectPath from 'object-path'

export const checkSearchField = (jsonForm, uiKey) => {
  let fieldSearch = objectPath.get(jsonForm, 'search') || {}
  let searchTable = objectPath.get(jsonForm, 'searchTable') || []
  let allSearch = [...searchTable, fieldSearch]
  let foundSearch = allSearch.find(({ pathParams = [], queryParams = [] }) => {
    let foundPath = pathParams.find((param) => param.key === uiKey)
    let foundQuery = queryParams.find((param) => param.key === uiKey)
    return foundPath || foundQuery
  })
  return foundSearch ? true : false
}

export const updateSearchField = ({
  jsonForm: jsonForm,
  setJsonForm: setJsonForm,
  searchKey: searchKey,
  groupKey: groupKey,
  value: value,
}) => {
  let searchField = objectPath.get(jsonForm, 'search.field') || []
  let foundIndex = searchField.findIndex((item) => item.key === searchKey)
  if (foundIndex > -1) {
    objectPath.set(searchField[foundIndex], 'field', value)
    objectPath.set(searchField[foundIndex], 'name', value)
    objectPath.set(searchField[foundIndex], 'groupKey', groupKey)
    objectPath.set(jsonForm, 'search.field', searchField)
    setJsonForm(jsonForm)
  }
}

export const deleteSearchField = ({
  jsonForm: jsonForm,
  setJsonForm: setJsonForm,
  searchKey: searchKey,
}) => {
  let searchField = objectPath.get(jsonForm, 'search.field') || []
  let foundIndex = searchField.findIndex((item) => item.key === searchKey)
  if (foundIndex > -1) {
    searchField.splice(foundIndex, 1)
    objectPath.set(jsonForm, 'search.field', searchField)
    setJsonForm(jsonForm)
  }
}

export const addSearchField = ({
  jsonForm: jsonForm,
  setJsonForm: setJsonForm,
  searchKey: searchKey,
  groupKey: groupKey,
  value: value,
}) => {
  let searchField = objectPath.get(jsonForm, 'search.field') || []
  let param = {
    formDesignId: jsonForm.formDesignId,
    collection: '',
    collectionName: '',
    key: searchKey,
    field: value,
    name: value,
    groupKey: groupKey,
  }
  searchField.push(param)
  objectPath.set(jsonForm, 'search.field', searchField)
  setJsonForm(jsonForm)
}
